/**
 *
 * @returns Object with initial address
 */
export function initialAddress() {
  return {
    street1: '',
    street2: '',
    city: '',
    countryId: 840,
    stateId: 19,
    stateProvinceRegion: '',
    zip: '',
    zipPostalcodePostcode: '',
  };
}
